export enum SessionState {
  Idle = "idle",
  Listening = "listening",
  Paused = "paused",
  Dialing = "dialing",
  Connected = "connected",
  Stopping = "stopping",
}

export interface SessionRecording {
  url: string;
  timestamp: string;
  duration: number;
  status: "recording" | "completed" | "failed";
}

export interface RecordingSessionMetadata {
  recordings?: SessionRecording[];
  hasConsent?: boolean;
  // ... any existing metadata fields ...
}
